import Nullstack from 'nullstack';
export default function IconForklift({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-forklift",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "14",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "17",
    x2: "12",
    y2: "17"
  }), "   ", Nullstack.element("path", {
    d: "M3 17v-6h13v6"
  }), "   ", Nullstack.element("path", {
    d: "M5 11v-4h4"
  }), "   ", Nullstack.element("path", {
    d: "M9 11v-6h4l3 6"
  }), "   ", Nullstack.element("path", {
    d: "M22 15h-3v-10"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "13",
    x2: "19",
    y2: "13"
  }), " ");
}